import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { API_ENDPOINT, RUPEE_SYMBOL } from '../../constants/constants';
import { getDateFormat, getHeader } from '../../utils/util';
import CustomCircularP from '../widgets/customCircularP';
import MyModal from '../widgets/myModal/myModal';
import AddTopup from './AddTopup';

const EyeIcon = () => (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M2.06 12.35a1 1 0 0 1 0-.7 10.75 10.75 0 0 1 19.88 0 1 1 0 0 1 0 .7 10.75 10.75 0 0 1-19.88 0" /><circle cx="12" cy="12" r="3" /></svg>
)

const Topups = ({ showAdd, setShowAdd }) => {
    const [plans, setPlans] = useState([])
    const [loading, setLoading] = useState(false)
    const [currentPlan, setCurrentPlan] = useState(null)
    const [currentMode, setCurrentMode] = useState("add")

    useEffect(() => { loadPlans() }, [])

    function loadPlans() {
        setLoading(true)
        axios.get(API_ENDPOINT + 'admin/get-topups', getHeader()).then(res => {
            setLoading(false)
            const d = res.data
            if (d.success) {
                d.message.sort((a, b) => (a.isActive === b.isActive) ? 0 : (a.isActive ? -1 : 1));
                setPlans(d.message)
            }
        })
    }
    const onViewPlan = (cpl) => {
        setCurrentPlan(cpl)
        setCurrentMode("view")
        setShowAdd(true)
    }
    const onActionDone = () => {
        setShowAdd(false)
        setCurrentPlan(null)
        setCurrentMode("add")
        loadPlans()
    }
    const closeModal = (v) => {
        setShowAdd(v)
        if (!v) { setCurrentPlan(null); setCurrentMode("add") }
    }

    return (
        <div>
            <MyModal
                showModal={showAdd}
                title={currentMode === "add" ? "Add Topup" : "Topup Details"}
                setShowModal={closeModal}
                modalC={<AddTopup show={showAdd} onActionDone={onActionDone} mode={currentMode} plan={currentPlan} />}
            />
            <CustomCircularP show={loading} />
            <div style={{ background: 'var(--color-surface)', padding: '6px 18px 12px' }}>
                <table className="table">
                    <thead>
                        <tr>
                            <th>#</th>
                            <th>Name</th>
                            <th>Price ({RUPEE_SYMBOL})</th>
                            <th>Candidates</th>
                            <th>Discount</th>
                            <th>Created</th>
                            <th>Status</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        {plans.map((od, i) => (
                            <tr key={od._id || i}>
                                <td className="text-muted">{i + 1}</td>
                                <td>
                                    <span style={{ display: 'inline-flex', alignItems: 'center', gap: 8 }}>
                                        <span style={{ width: 10, height: 10, background: od.color, display: 'inline-block', border: '1px solid var(--color-divider)' }}></span>
                                        <span style={{ fontWeight: 600 }}>{od.name}</span>
                                    </span>
                                </td>
                                <td style={{ fontFamily: 'var(--font-heading)', fontWeight: 800 }}>{od.price}</td>
                                <td>{od.count}</td>
                                <td>{od.discount}</td>
                                <td className="text-muted">{getDateFormat(new Date(od.createdOn))}</td>
                                <td><span className={od.isActive ? 'tag tag-accent' : 'tag tag-neutral'}>{od.isActive ? 'Active' : 'Inactive'}</span></td>
                                <td>
                                    <button className="btn btn-icon btn-secondary" aria-label="View" onClick={() => onViewPlan(od)}><EyeIcon /></button>
                                </td>
                            </tr>
                        ))}
                        {plans.length === 0 && !loading && (
                            <tr><td colSpan={8} className="text-muted" style={{ textAlign: 'center', padding: 24 }}>No topups yet</td></tr>
                        )}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default Topups;
